export default {
  isLoaded: false,
  notifications: [],
  notificationCount: {},
}
